import {createReducer, sortBy} from 'helpers';

export const calendars = createReducer([], {
  GOOGLE_CALENDAR_LIST_RECEIVED: (state, action) => {
    const calendars = action.items.map(item => ({
      accessRole: item.accessRole,
      description: item.description,
      id: item.primary ? 'primary' : item.id,
      primary: item.primary,
      summary: item.summary,
    }));
    return sortBy(calendars, 'primary', 'accessRole', 'summary');
  },
  GOOGLE_CALENDAR_SIGNED_OUT: () => [],
});
